import { useQuery, useMutation } from "@tanstack/react-query";
import { adverseEventAssessmentApiService } from "./adverseeventassessment.api";

interface UseAdverseEventAssessmentOptions {
  adverseeventid?: number | null;
  enabled?: boolean;
}

export const useAdverseEventAssessmentApi = (options?: UseAdverseEventAssessmentOptions) => {
  const SelectQuery = useQuery({
    queryKey: ["adverse-event-assessment-select", options?.adverseeventid],
    queryFn: () =>
      adverseEventAssessmentApiService.getSelectById({
        adverseeventid: options?.adverseeventid,
      }),
    enabled: !!options?.adverseeventid && (options?.enabled ?? true),
  });

  const UpdateMutation = useMutation({
    mutationFn: (data: any) => adverseEventAssessmentApiService.updateData(data),
  });

  return {
    SelectQuery,
    UpdateMutation,
  };
};
